import React from 'react'
import BlogPost from './BlogPost'

export default function TwoCountriesTwoLives() {
  return (
    <BlogPost
      translationKey="twoCountriesTwoLives"
      seoTitle="Two Countries, Two Lives, and Me | Hyunjin Jae"
      seoDescription="A reflection on living between two countries and the lessons learned from both experiences."
      seoKeywords="two countries, two lives, reflection, personal growth, Korea, United States"
      seoTags={['reflection', 'two countries', 'two lives', 'Korea', 'United States']}
    />
  )
} 